import 'core-js/features/array/find-index';

import { useContext, useEffect } from 'react';

import { EventType } from '../components/ApiClientsContext';
import { LocationContext } from '../components/LocationContext';
import { EventLocation } from '../LegacyModal/EventForm';
import { bookingEntryAddressParser } from './addressComponentHelper';

interface UseBookingsAddress {
  setFieldValue: Function;
  // @ts-ignore
  values;
  eventType?: EventType;
}

interface SetValues {
  index: number;
  gdsAddress: EventLocation;
  vendorName?: string | null;
}

export const useBookingsAddressLegacy = ({ setFieldValue, values, eventType }: UseBookingsAddress): void => {
  const {
    location: { CER, REC },
  } = useContext(LocationContext);

  const setValues = ({ index, gdsAddress = {}, vendorName }: SetValues): void => {
    setFieldValue(`events[${index}].location.zip`, gdsAddress.zip);
    setFieldValue(`events[${index}].location.city`, gdsAddress.city);
    setFieldValue(`events[${index}].location.state`, gdsAddress.state);
    setFieldValue(`events[${index}].location.country`, gdsAddress.country);
    setFieldValue(`events[${index}].location.street1`, gdsAddress.street1);
    setFieldValue(`events[${index}].location.name`, vendorName);
  };

  useEffect(() => {
    if (eventType === 'WeddingEvent') {
      return;
    }
    if (CER) {
      const index = 0;

      const { gdsAddress = {}, vendor_name } = bookingEntryAddressParser(CER);
      setValues({ index, gdsAddress, vendorName: vendor_name });
    }

    if (REC) {
      const index = 1;

      const { gdsAddress = {}, vendor_name } = bookingEntryAddressParser(REC);
      setValues({ index, gdsAddress, vendorName: vendor_name });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, CER, REC]);
};
